import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import FrontPageHero from "../components/FrontpageHero"
import FrontPageContent from "../components/FrontpageContent"
import SEO from "../components/seo"

const IndexPage = () => (
  <Layout>
    <SEO title="Accueil" />
    <FrontPageHero />
    <FrontPageContent />
  </Layout>
)

export default IndexPage
